import type { FunctionComponent, ReactNode } from 'react';
import { createContext, useContext, useState } from 'react';

import type { TabType } from './TabNavigation';

type TabContextType = {
    readonly activeTab: TabType;
    readonly setActiveTab: (tab: TabType) => void;
};

const TabContext = createContext<TabContextType | undefined>(undefined);

type TabProviderProps = {
    readonly children: ReactNode;
    readonly initialTab?: TabType;
};

export const TabProvider: FunctionComponent<TabProviderProps> = ({ children, initialTab = 'chat' }) => {
    const [activeTab, setActiveTab] = useState<TabType>(initialTab);

    const value: TabContextType = {
        activeTab,
        setActiveTab,
    };

    return <TabContext.Provider value={value}>{children}</TabContext.Provider>;
};

export const useTabContext = (): TabContextType => {
    const context = useContext(TabContext);
    if (context === undefined) {
        throw new Error('useTabContext must be used within a TabProvider');
    }

    return context;
};
